import { upsellElements } from './upsellElements';

export const storeCartSKUs = () => {
  const { cartModal } = upsellElements();
  const cartItems = cartModal.querySelectorAll('.w-commerce-commercecartitem');

  const cartSKUs: string[] = [];
  if (cartItems && cartItems[0]) {
    cartItems.forEach((itemElement) => {
      for (let i = 0; i < cartItems.length; i++) {
        const cartItemSkuArray = itemElement.querySelectorAll(
          `[data-wf-bindings="%5B%7B%22innerHTML%22%3A%7B%22type%22%3A%22PlainText%22%2C%22filter%22%3A%7B%22type%22%3A%22identity%22%2C%22params%22%3A%5B%5D%7D%2C%22dataPath%22%3A%22database.commerceOrder.userItems.${i}.sku.f_sku_%22%7D%7D%5D"]`
        );
        const sku = cartItemSkuArray[0]?.innerHTML;
        if (sku) {
          cartSKUs.push(sku);
          break;
        }
      }
    });
  }

  localStorage.setItem('fp-skus', JSON.stringify(cartSKUs));
  return { cartSKUs };
};
